import { fetchStatus } from 'src/shared/constants';

export const getQuote = ({ quote }) => quote;
export const getQuoteId = ({ quote }) => quote.quoteId;
export const getUser = ({ oidc }) => oidc.user;
export const getIsAxiosAuthorized = ({ auth }) => auth.isAxiosAuthorized;
export const getCreateQuoteFulfilled = ({ quiz }) =>
  quiz.quote.fetchStatus === fetchStatus.fulfilled;
export const getCreateQuoteRejected = ({ quiz }) => quiz.quote.fetchStatus === fetchStatus.rejected;
